/* import __COLOCATED_TEMPLATE__ from './selected-section.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
let SelectedSection = (_class = class SelectedSection extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "selectedSection", _descriptor, this);
  }
  get sectionSelected() {
    if (this.showSectionType) {
      return this.selectedSection;
    }
    return undefined;
  }
  get composer() {
    return this.args.composer;
  }
  get showSectionType() {
    return this.composer.state.showSectionType;
  }
  get calculatePosition() {
    let sectionDiv = this.selectedSectionDomElement;
    if (!sectionDiv) {
      return '';
    }
    let boundingRect = sectionDiv.getBoundingClientRect();
    // Need to reposition to have the exact same position than
    // the section type in table-spec.ts
    let top = boundingRect.top - 1;
    let left = boundingRect.left + 1;
    return sanitizeHtml(`top: ${top}px; left: ${left}px;`);
  }
  get sectionType() {
    return this.selectedSection?.node.attrs.sectionType;
  }
  updateSelectedSection() {
    this.selectedSection = this.selectedSectionNode;
  }
  get selectedSectionNode() {
    return this.args.composer.state.selectedSection;
  }
  get selectedSectionDomElement() {
    if (!this.selectedSection) {
      return null;
    }
    let tbodyDomNode = this.args.composer.findDomAtDocumentPosition(this.selectedSection.start).node;
    if (!tbodyDomNode.parentElement) {
      return null;
    }
    let tableDomNode = tbodyDomNode.parentElement;
    if (!tableDomNode.parentElement) {
      return null;
    }
    return tableDomNode.parentElement;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "selectedSection", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.selectedSectionNode;
  }
}), _applyDecoratedDescriptor(_class.prototype, "updateSelectedSection", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateSelectedSection"), _class.prototype)), _class);
export { SelectedSection as default };